var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPandasIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 10,
    x: 18,
    y: 4,
    fill: "#1a237e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 10,
    x: 18,
    y: 25,
    fill: "#1a237e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 18,
    y: 17,
    fill: "#fbc02d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 33,
    x: 10,
    y: 13,
    fill: "#1a237e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 10,
    x: 26,
    y: 33,
    fill: "#1a237e"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 10,
    x: 26,
    y: 12,
    fill: "#1a237e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 26,
    y: 25,
    fill: "#ff4081"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 33,
    x: 34,
    y: 2,
    fill: "#1a237e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandasIcon);
export default __webpack_public_path__ + "static/media/pandasIcon.6143b4ca89f7f8a8d4039321acf685a8.svg";
export { ForwardRef as ReactComponent };